import { FC } from 'react';
import { Input, InputProps } from '../../UI';
import { useTranslation } from 'react-i18next';
import { RealEstateFormValues } from '../types';
import { useFormContext } from 'react-hook-form';

type RealEstateStreetAddressOneInputProps = Pick<InputProps, 'className'>;

export const RealEstateStreetAddressOneInput: FC<RealEstateStreetAddressOneInputProps> = ({ className }) => {
  const { t: tForm } = useTranslation('form');
  const { register, formState } = useFormContext<RealEstateFormValues>();

  return (
    <Input
      className={className}
      {...register('streetOne')}
      status={formState.errors.streetOne ? 'errored' : 'normal'}
      label={tForm('real-estate-property-street-address-one-input-label')}
    />
  );
};
